import { EventEmitter, Injectable } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { StorageService } from '../shared/services/storage.service';
// import { resource } from 'src/app/app.language';
import { AppService } from '../shared/services/app.service';
import {loginLang} from './login.keys';

@Injectable({
    providedIn: 'root'
})
export class TranslateService {

   private languageKey = "appLanguage";
    public defaultLanguageCode = "en";
    constructor(private storageService: StorageService, private appService: AppService) {
    }

    /**
     * Configure Language in system
     * @param Language Language Key
     */
    setLanguage(language,callback) { // Review again this code
        if (language) {
            this.storageService.setData(this.languageKey, language, () => {
                callback();
            });
        } else {
            this.storageService.setData(this.languageKey, this.defaultLanguageCode, () => {
                callback();
            });
        }
    }

    getLanguage(callback) { // Review again this code
        this.storageService.getDataString(this.languageKey, (data) => {
            if (data) {
                callback(data);
            }else{
                callback(this.defaultLanguageCode);
            }
        });
    }

    /**
     * Return Translate value
     * @param key key name is coming from json or on page
     */
    public translate(key: string): Observable<string> {
        return new Observable(observer => {
            this.storageService.getDataString(this.languageKey, (lang) => {
                if (!lang) lang = this.defaultLanguageCode;
                try {
                    let resouceDef: any;
                    if(this.appService._appData && this.appService._appData.language_json){
                        resouceDef = this.appService._appData.language_json[lang];
                    }else{
                        var base_ln;
                        var local_ln_exist = lang.includes('-');
                        if(local_ln_exist) base_ln = lang.split('-')[0]
                        else  base_ln = lang; 
                        resouceDef = loginLang[base_ln];
                    }
                    var objTrans = resouceDef[key];
                        if (objTrans == undefined) {
                            if (key == "")
                                objTrans = key;
                            else
                                objTrans = key; //+ "?";
                        }
                    observer.next(objTrans);
                } catch (e) {
                    observer.next(key);
                }
            });
        });
    }

    async translateSync(key: string): Promise<string> {
        return await firstValueFrom(this.translate(key));
    }
}
